import api from "../axiosIntercepture";

/**
 * GET Location ID
 */
export const getLocationId = async () => {
  try {
    const response = await api.get("/ordermanagement/getLocationId");
    return response.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
};

/**
 * CREATE Location
 */
export const createLocation = async (locationData) => {
  try {
    const response = await api.post("/ordermanagement/createLocation", locationData);
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
};

/**
 * GET Location List with Pagination
 */
export const getLocationList = async (page, pageSize) => {
  try {
    const response = await api.post(
      `/ordermanagement/getLocationList?page=${page+1}&limit=${pageSize}`
    );
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
};

/**
 * UPDATE Location
 */
export const updateLocationAPI = async (locationData,id) => {
  try {
    const response = await api.post(
      `/ordermanagement/updateLocation/${id}`,
      locationData
    );
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
};


// getLocation autoComplete
export const getLocationCodeAutoAPI = async (locationIDD) => {
  try {
    const response = await api.post(
      `/ordermanagement/getLocationCode?locationID=${locationIDD}`,
    );
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
};
